function isEventTarget(el) {
    if (window.EventTarget) {
        return el instanceof EventTarget;
    }
    else {
        return typeof el.addEventListener == 'function';
    }
}
export function on() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var el = isEventTarget(args[0]) ? args.shift() : window;
    var event = args.shift();
    var filter = typeof args[0] == 'string' ? args.shift() : null;
    var _a = makeHandler(args[0], args[1], args[2]), handler = _a[0], options = _a[1];
    var final;
    if (filter) {
        final = function (e) {
            if (!(e.target instanceof Element))
                return;
            if (!e.target.closest(filter))
                return;
            if (options && options.stop)
                e.stopPropagation();
            if (options && options.prevent)
                e.preventDefault();
            handler(e);
        };
    }
    else if (options && (options.prevent || options.stop)) {
        final = function (e) {
            if (options.stop)
                e.stopPropagation();
            if (options.prevent)
                e.preventDefault();
            handler(e);
        };
    }
    else {
        final = handler;
    }
    var enames = event.split(' ').map(function (e) { return e.trim(); });
    for (var _b = 0, enames_1 = enames; _b < enames_1.length; _b++) {
        var e = enames_1[_b];
        el.addEventListener(e, final, options || false); // TODO add opts arg maybe
    }
    return function () {
        for (var _i = 0, enames_2 = enames; _i < enames_2.length; _i++) {
            var e = enames_2[_i];
            el.removeEventListener(e, final, options || false);
        }
    };
}
function makeHandler(arg1, arg2, arg3) {
    if (!arg1)
        throw new TypeError('No handler passed to on()');
    if (typeof arg1 == 'function')
        return [arg1, arg2 || undefined];
    if (!arg2)
        throw new TypeError('Just the object passed to on()');
    var hdl = typeof arg2 == 'string' ? arg1[arg2] : arg2;
    if (typeof hdl != 'function')
        throw new TypeError('Invalid handler passed to on()');
    return [hdl.bind(arg1), arg3 || undefined];
}
//# sourceMappingURL=on.mjs.map